import { render, staticRenderFns } from "./STTab.vue?vue&type=template&id=7c9370b6&"
import script from "./STTab.vue?vue&type=script&lang=js&"
export * from "./STTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports